/** Severity bar endpoint labels — matches SkinRoutinePage concern preview. */
import { canonicalSkinConditionName } from './skinResultsUtils';

export function getSeverityBarLabels(concernName) {
  const name = canonicalSkinConditionName(concernName) || String(concernName || '').trim();
  if (name === 'Hydration') {
    return { left: 'Severe', middle: 'Average', right: 'Good', triple: true };
  }
  const leftMap = {
    Oxygen: 'Poor',
    Dullness: 'Dull',
    Smoothness: 'Rough',
    UnevenSkin: 'Uneven',
  };
  const rightMap = {
    Oxygen: 'Rich',
    Dullness: 'Radiant',
    Smoothness: 'Smooth',
    UnevenSkin: 'Even',
  };
  return {
    left: leftMap[name] || 'Low',
    right: rightMap[name] || 'Good',
    triple: false,
  };
}
